<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" lazy-validation>
            <v-card-title>Modification Auteur</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="authorInfo.name"
                    label="Nom de l'auteur"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="authorInfo.subtitle"
                    label="Nom de l'auteur"
                    outlined
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <h3>Bibliography</h3>
                  <VueEditor
                    v-model="authorInfo.bibliography"
                    auto-grow
                    outlined
                    label="Biographie"
                    placeholder="Biographie de l'auteur"
                    required
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <h3>Certification</h3>
                  <VueEditor
                    v-model="authorInfo.certification"
                    auto-grow
                    outlined
                    label="Biographie"
                    placeholder="Biographie de l'auteur"
                    required
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="expertSelected"
                    :items="expertList"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    chips
                    small-chips
                    label="Experts"
                    multiple
                  >
                    <template #item="{ item }">
                      <v-list-item @click="toggleItem(item)">
                        <v-list-item-action>
                          <v-checkbox
                            color="primary"
                            :input-value="isSelected(item)"
                          />
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.name }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="authorInfo.websiteUrl"
                    auto-grow
                    outlined
                    label="Site web"
                    placeholder="Site web"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <vue-upload-multiple-image
                    v-if="authorInfo.name"
                    style="margin-left: 160px"
                    v-model="images"
                    :data-images="images"
                    accept="image/*	"
                    name="images"
                    drag-text="Veuillez ajoutez une images svp!"
                    browse-text="Browse image"
                    primary-text="Primary image"
                    mark-is-primary-text="Set default image"
                    :min-image="1"
                    :multiple="false"
                    :showEdit="false"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                  >
                  </vue-upload-multiple-image>
                  <v-progress-linear
                    v-if="showlowding && uploadPercentage < 100"
                    style="max-width: 190px; margin-left: 160px"
                    color="primary"
                    indeterminate
                    rounded
                    height="15"
                    ><strong
                      >{{ Math.ceil(uploadPercentage) }}%</strong
                    ></v-progress-linear
                  >
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn class="info" @click="confirmEdit()">
                      Modifier
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogEditAuthor" persistent max-width="600">
        <v-card>
          <v-card-title style="text-align: center" class="justify-center mb-2">
            Êtes-vous sûr de vouloir modifier cet auteur ?
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1" text @click="cancelEdit">
              Annuler
            </v-btn>

            <v-btn
              color="info darken-1"
              :loading="isLoading"
              text
              @click="updateAuthor"
            >
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar
      :color="snackbar.color"
      v-model="snackbar.visible"
      :top="snackbar.position === 'top'"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </section>
</template>

<script>
import axios from "axios";
import Constant from "@/utils/constants";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import store from "../../../store/image";
import constants from "@/utils/constants";

export default {
  components: { VueEditor, VueUploadMultipleImage },
  data() {
    return {
      imagesId: "1",
      images: [],
      dialogEditAuthor: false,
      isLoading: false,
      showlowding: false,
      expertSelected: [],

      expertList: [],
      authorInfo: {
        id: "",
        name: "",
        subtitle: "",
        imgDBUrlId: 0,
        bibliography: "",
        websiteUrl: "",
      },
      snackbar: {
        text: "",
        color: "",
        visible: false,
        position: "top",
      },
    };
  },
  async beforeRouteEnter(to, from, next) {
    const authorId = to.params.id;
    try {
      const response = await axios.get(
        `${Constant.QORANI}authorCertificate/get/${authorId}`
      );
      const expertList = await axios.get(`${constants.QORANI}expert/getall`);
      console.log("dddd", expertList.data);

      next((vm) => {
        vm.expertList = expertList.data;
        vm.authorInfo = response.data;
        response.data.expertResponseList.map((expert) => {
          vm.expertSelected.push(expert.id);
          console.log(expert.id);
        });
        const imagePath = response.data.imgDBId
          ? vm.getImageUrl(response.data.imgDBId)
          : response.data.imageUrl;
        vm.images.push({
          name: "",
          path: imagePath,
          highlight: 1,
          default: 1,
        });
        console.log(vm.images);
      });
    } catch (error) {
      console.error("Error fetching author details:", error);
      next(false);
    }
  },
  methods: {
    async removeExpertFromAuthor(expertId, authorId) {
      const res = await axios.get(
        `${constants.QORANI}authorCertificate/removeExpert/${expertId}/fromCertificate/${authorId}`
      );
    },
    toggleItem(item) {
      const index = this.expertSelected.indexOf(item.id);
      if (index === -1) {
        this.expertSelected.push(item.id);
      } else {
        this.expertSelected.splice(index, 1);
        this.removeExpertFromAuthor(item.id, this.authorInfo.id);
      }
    },
    isSelected(item) {
      return this.expertSelected.includes(item.id);
    },
    async loadImage(item) {
      if (item.fileUrlDBType === "svg") {
        try {
          const response = await fetch(
            `${Constant.QORANI}fileDB/files/${item.fileUrlDBId}`
          );
          if (!response.ok)
            throw new Error("Échec du chargement de l'image SVG");

          let svgContent = await response.text();

          // Ajoute width et height directement dans le SVG
          svgContent = svgContent
            .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

          item.svgContent = svgContent; // Stockage dans l'objet item
        } catch (error) {
          console.error("Erreur lors du chargement de l'image :", error);
        }
      } else {
        item.imgUrl = `${Constant.QORANI}fileDB/files/${item.fileUrlDBId}`;
      }
    },

    getImageUrl(imgDBId) {
      return `${Constant.QORANI}fileDB/files/${imgDBId}`;
    },
    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        const imageId = store.state.imageId;
        this.authorInfo.imgDBUrlId = imageId;
        // console.log("Image id :", imageId);
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },
    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.images.indexOf(fileList[index].path);
        this.authorInfo.imageUrl = "";
        this.authorInfo.imgId = "";
        if (index > -1) {
          this.images.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    confirmEdit() {
      // this.dialogEditAuthor = true;
      this.updateAuthor();
    },
    async addExpertToAuthor(expertSelected, authorId) {
      try {
       await expertSelected.map(async (expertId) => {
          const res = await axios.get(
            `${constants.QORANI}authorCertificate/addExpert/${expertId}/toCertificate/${authorId}`
          );
          console.log(res);
        });
        
      } catch (error) {
        this.snackbar.text =
          "Une erreur est survenue lors de l'ajout de l'auteur. Veuillez réessayer plus tard.";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
      this.AuthorName = "";
      this.AuthorDescription = "";

      this.snackbar.text = "L'auteur a été ajouté avec succès !";
      this.snackbar.color = "success";
      this.snackbar.visible = true;
    },
    async updateAuthor() {
      // const imageId = store.state.imageId;
      // this.authorInfo.imgDBUrlId = imageId;
      this.isLoading = true;
      console.log(this.authorInfo);
      if (this.expertSelected.length > 0) {
        this.addExpertToAuthor(this.expertSelected, this.authorInfo.id);
      }
      
      try {
        const response = await axios.post(
          `${Constant.QORANI}authorCertificate/edit/${this.authorInfo.id}`,
          this.authorInfo
        );

        if (response.status === 200) {
          this.snackbar.text = "L'auteur a été modifié avec succès !";
          this.snackbar.color = "success";
          this.snackbar.visible = true;
          this.dialogEditAuthor = false;

          setTimeout(() => {
            this.$router.push({ name: "Author" });
          }, 1000);
        } else {
          this.snackbar.text = "Erreur lors de la modification de l'auteur.";
          this.snackbar.color = "error";
          this.snackbar.visible = true;
        }
      } catch (error) {
        console.error("Failed to update author:", error);
        this.snackbar.text =
          "Une erreur est survenue lors de la modification de l'auteur.";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      } finally {
        this.isLoading = false;
      }
    },
    cancelEdit() {
      this.dialogEditAuthor = false;
    },
  },
};
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
